import React from 'react';


const LogoDTImage = '/assets/images/LogoDT.png';


interface LogoDTProps {
  className?: string;
  alt?: string;
}

export const LogoDT: React.FC<LogoDTProps> = ({ 
  className = 'w-16 h-16 rounded-full p-1', 
  alt = 'DT', 
}) => (
  <img 
    src={LogoDTImage} 
    alt={alt} 
    className={className}
  />
);